import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Option} from "../../interfaces/theme-option.interface";
import {ThemeService} from "../../services/theme.service";

@Component({
  selector: "app-menu",
  templateUrl: "./theme-menu.component.html",
  styleUrls: ["./theme-menu.component.css"]
})
export class ThemeMenuComponent {
  @Input() options: Array<Option> | null;
  @Output() themeChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private themeService: ThemeService) {
    this.options = new Array<Option>();
  }

  changeTheme(themeToSet: any) {
    this.themeChange.emit(themeToSet);
  }
}
